import React, {useEffect, useState} from "react";
import {Link, useNavigate, useParams} from "react-router-dom";
import {programsService} from "../../../services/programsService/programsService";
import {PageErrorMessage} from "../../../components/PageErrorMessage";
import Loader from "../../../components/common/Loader";
import TextEditorContent from "../../../components/TextEditorContent";
import ProgramMasterclassList from "./ProgramMasterclassList";
import AchievementsListCard from "../../../components/Achievements/AchievementsListCard";
import UserDetails from "../../../components/UserDetails";

const PreviewProgram = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [programDetails, setProgramDetails] = useState(null);
    const { id } = useParams();
    const navigate = useNavigate();
    const [error, setError] = useState(null);

    const programPreviewData = async () => {
        setIsLoading(true);
        try {
            await programsService.getProgramPreviewData(id).then((response) => {
                setProgramDetails(response?.data);
            });
            setIsLoading(false);
        } catch (error) {
            setError({
                statusCode: error.response.status,
                message: error.response.data.message,
            });
            setIsLoading(false);
        }
    };

    // useEffect of call all api function
    useEffect(() => {
        programPreviewData();
    }, [id]);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    if (error) {
        return <PageErrorMessage
            error={error}
            entityTitle="Program"
        />;
    }

    return (
        <>
            {isLoading ? (
                <>
                    <Loader />
                </>
            ) : (
                <>
                    <div className="container-fluid">
                        <div className="row mb-5 py-5 px-4 program__content">
                            <div className="col-md-6 text-center">
                                <div className="program__image">
                                    <img
                                        src={programDetails?.cover_image}
                                        alt={programDetails?.title}
                                        className="img-fluid"
                                    />
                                </div>
                            </div>

                            <div className="col-md-6 mb-4 mb-md-0">
                                <h1>{programDetails?.name}</h1>
                                <TextEditorContent
                                    text={programDetails?.description}
                                />
                                <div className="fs-6 lh-base fw-bolder mb-3">
                                    Speakers:
                                </div>
                                {programDetails?.speakers.length > 0 &&
                                    <div className="d-flex flex-wrap">
                                        {programDetails?.speakers?.map((speaker) => {
                                            return (
                                                <div className="program-preview__speakers__item-wrapper">
                                                    <Link className="text-decoration-none color-white" to={`/community/users/${speaker.id}`}>
                                                        <UserDetails user={speaker} />
                                                    </Link>
                                                </div>
                                            );
                                        })}
                                    </div>
                                }
                                <div className="d-flex align-center mt-3">
                                    <div className="fs-6 lh-base fw-bolder">
                                        Credit Hours: {programDetails?.credit_hours}
                                    </div>
                                </div>
                                {programDetails?.badges.length > 0 &&
                                    <div className="mt-3">
                                        <AchievementsListCard
                                            achievements={programDetails?.badges}
                                            title="Achievements to Unlock"
                                        />
                                    </div>
                                }
                            </div>
                        </div>
                        <ProgramMasterclassList
                            masterClasses={programDetails?.master_classes}
                            title="Unlock access to the following masterclasses:"
                            isPreview={false}
                        />
                    </div>
                </>
            )}
        </>
    );
};

export default PreviewProgram;